import React from 'react';

export const GroupItem = (props) => {
    const {
              categoryId,
              name,
              imgSrc,
              onClick
          } = props;


    return (<li className="kiosk-item" onClick={() => onClick(categoryId)}>
            <div className="__image">
                <img src={imgSrc} alt={name} />
            </div>
            <div className="__name">{name}</div>
        </li>);
}
